import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Subscription from "~/models/Subscription/Subscription";

@observer
class SubscriptionCancelAtPeriodEndCardDescription extends Component {
  render() {
    const { t, subscription } = this.props;

    if (!subscription.cancelAtPeriodEnd) {
      return null;
    }

    return (
      <Card.Description>
        {t("billingCentral:subscriptionActiveUntil", {
          endOfCurrentBillingCycleDate: subscription.endOfCurrentBillingCycleDate.format("MMMM Do YYYY"),
        })}
      </Card.Description>
    );
  }
}

SubscriptionCancelAtPeriodEndCardDescription.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
};

export default withTranslation()(SubscriptionCancelAtPeriodEndCardDescription);
